import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Ссылки старого вида `/invite/<токен>`, выданные до 15.10: переводим на
 * `/invite#<токен>`, где токен не попадает в журналы. Новые ссылки сразу
 * такие (`inviteUrl`).
 */
export const Route = createFileRoute("/invite_/$token")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/invite", hash: params.token });
  },
});
